import React, { useState, useEffect } from 'react';
import { Button, Container, Grid, TextField } from '@material-ui/core';
import { getBacchusURL, handleError, remainingTime } from '../shared/Functions';
import { authProvider } from '../../services/Security';
import { Autocomplete } from '@material-ui/lab';
import { DistrictsVService, OperatorsVService } from '../../services/V2/padre';

export const RecurringListing = (props) => {
    const [operators, setOperators] = useState<any[]>([]);
    const [operator, setOperator] = useState<any>();
    const [canReadOperators, setCanReadOperators] = useState<boolean>(false);
    const [resetToken, setResetToken] = useState<boolean>(false);
    const [district, setDistrict] = useState<any>();
    const [districts, setDistricts] = useState<any[]>([]);
    const [canReadDistricts, setCanReadDistricts] = useState<boolean>(false);

    const url = getBacchusURL();

    const loadIframe = () => {
        authProvider.getNexusTokenFull().then(token => {
            setTimeout(() => setResetToken(!resetToken), remainingTime(token.tokenExpires));

            const frame = document.getElementById('autopay-signups') as HTMLIFrameElement;
            frame?.contentWindow?.postMessage(JSON.stringify({
                token: token,
                operatorId: operator?.id,
                districtId: district?.id
            }), url);
        });
    }

    useEffect(() => {
        authProvider.getNexusToken().then(token => {
            let perms = authProvider.getPermissions(token);
            setCanReadOperators(perms.some((perm: string) => perm === "ReadOperator"));
            setCanReadDistricts(perms.some((perm: string) => perm === "ReadDistrict"));
        })
    }, [])

    useEffect(() => {
        if(operators.length > 0) return;
        let operatorId = authProvider.getUser()?.OperatorId;
        if(!operatorId && canReadOperators){
            OperatorsVService.operatorsVGetAll({
                    pageNumber: 1,
                    orderBy: "Name",
                    orderByDesc: false
                })
                .then(o => {
                    setOperators(o.items ?? [])
                })
                .catch(err => handleError(err));
        } else if(operatorId && canReadOperators){
            OperatorsVService.operatorsVGetById(operatorId)
                .then(o => {
                    setOperator(o);
                })
                .catch(err => handleError(err));
        }
    }, [operators, canReadOperators])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(operator && canReadDistricts){
            DistrictsVService.districtsVGetAllAnon(operator.id)
                .then(d => setDistricts(d))
                .catch(err => handleError(err));
        }
    }, [operator, canReadDistricts])// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <React.Fragment>
            <Container maxWidth="xl">
                <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
                    <div style={{ padding: '15px', margin: '0px' }}>
                        <h6 style={{ textAlign: "left", fontSize: "1.25rem", letterSpacing: "0.0075em", lineHeight: "1.6" }}>Autopay Signups Report</h6>
                        <div className="row col-12">
                            {operators &&
                                <Grid item xs={2}
                                    container={true}
                                    alignContent="flex-start">
                                    <Autocomplete
                                        value={operator || {}}
                                        id="operator"
                                        options={operators}
                                        getOptionLabel={(option) => option?.name ?? ""}
                                        renderOption={(option, { selected }) => (
                                            <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                        )}
                                        style={{ width: 250, paddingRight: "10px", color: "#fff", textAlign:"center" }}
                                        renderInput={(params) => <TextField style={{textAlign:"center"}} {...params} label="Operator" variant="outlined" />}
                                        getOptionSelected={(o, v) => o.id === v.id}
                                        onChange={(e, o) => {
                                                if(!operator) {
                                                    setDistrict(null);
                                                    setDistricts([]);
                                                }
                                                setOperator(o);
                                            }}
                                        />
                                </Grid>
                            }
                            {operator && districts &&
                                <Grid item xs={2}
                                    container={true}
                                    alignContent="flex-start">
                                    <Autocomplete
                                        value={district || {}}
                                        id="district"
                                        options={districts}
                                        getOptionLabel={(option) => option?.name ?? ""}
                                        renderOption={(option, { selected }) => (
                                            <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                        )}
                                        style={{ width: 300, paddingRight: "10px" }}
                                        renderInput={(params) => <TextField {...params} label="District" variant="outlined" />}
                                        getOptionSelected={(o, v) => o.id === v.id}
                                        onChange={(e, d) => {
                                                setDistrict(d);
                                            }}
                                        />
                                </Grid>
                            }
                        </div>
                        <div className="row col-12" style={{ paddingLeft: '15px', paddingBottom: '15px', margin:'0px' }}>
                            <Button onClick={loadIframe} color="primary">
                                View Recurring Listing
                            </Button>
                        </div>
                    </div>
                    <iframe
                        id="autopay-signups"
                        title="autopay-signups"
                        src={`${url}/#/app/autopay-signups`}
                        width="1600px"
                        height="590px"
                    />
                </div>
            </Container>
        </React.Fragment>
    );
}
